var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['programmatic-ad', { 'no-margin' : _vm.noMargin }, { 'mar-bottom-20' : _vm.bottomMargin }, { 'no-top-margin' : _vm.noTopMargin}, { 'force-728' : _vm.forceFluid  } ],attrs:{"id":_vm.getIndex}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40e5471a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProgrammaticAds.vue
// module id = null
// module chunks = 